/*
Breve descrizione (in italiano):
- Aggiunge una funzione angleDistance(a, b) che ritorna la distanza minima in gradi
  tra due angoli (valori numerici, possono essere fuori dall'intervallo 0-360).
- Normalizza gli angoli modulo 360 e restituisce un valore compreso tra 0 e 180.
- Fornisce sia export ES Module che compatibilità CommonJS se presente.

Esempi:
  angleDistance(10, 20)   -> 10
  angleDistance(359, 1)   -> 2

Comandi suggeriti per test (inclusi qui come commento):
  node -e "console.log(require('./src/angleDistance.js')(359,1))"
  node --input-type=module -e "import('./src/angleDistance.js').then(m=>console.log(m.angleDistance(359,1)))"
*/

function angleDistance(a, b) {
  // normalizza un angolo in [0, 360)
  const normalize = x => ((x % 360) + 360) % 360;

  const na = normalize(Number(a));
  const nb = normalize(Number(b));

  // differenza assoluta
  let diff = Math.abs(na - nb);

  // distanza minima sul cerchio
  if (diff > 180) diff = 360 - diff;

  return diff;
}

// Export ES Module
export { angleDistance };
export default angleDistance;

// Compatibilità CommonJS (se presente)
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = angleDistance;
}
